import { render, staticRenderFns } from "./admin-statistic-events-created-per-provider.vue?vue&type=template&id=0563b8de&scoped=true"
import script from "./admin-statistic-events-created-per-provider.vue?vue&type=script&lang=js"
export * from "./admin-statistic-events-created-per-provider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0563b8de",
  null
  
)

export default component.exports